module.exports = __webpack_public_path__ + "img/three.3e886816.svg";